'use strict';

var Transport = require('./transport');

Transport.register('websocket', require('./web_socket'));
Transport.register('eventsource', require('./event_source'));
Transport.register('long-polling', require('./xhr'));
Transport.register('cross-origin-long-polling', require('./cors'));
Transport.register('callback-polling', require('./jsonp'));

module.exports = Transport;



/*****************
 ** WEBPACK FOOTER
 ** ./src/transport/browser_transports.js
 ** module id = 21
 ** module chunks = 0
 **/